import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../../common/components/base.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import {HubApiService} from '../../../services/hub.api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FormBuilder} from '@angular/forms';
import { HubComponent } from '../hub.component';

@Component({
    selector: 'ig-hub-nav',
    templateUrl: './hub.nav.component.html',
    styleUrls: ['./hub.nav.component.scss']
})
export class HubNavComponent extends BaseComponent implements OnInit {
    public hubName: string;

    constructor(private hubApiService: HubApiService,
                private formBuilder: FormBuilder,
                private activatedRoute: ActivatedRoute,
                public parent: HubComponent,
                private router: Router,) {
        super({activatedRoute});
    }

    public ngOnInit() {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;
    }

    public goHome() {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.eventCalendar, {
            hubName: this.hubName
        }));
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/nav/hub.nav.component.ts